import { useCallback, useEffect, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export const useNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const locationRef = useRef(location)

  const navigateTo = useCallback(
    (location, state) => navigate(location, { state: location.state || state }),
    [navigate],
  )

  const navigateBack = useCallback(() => navigate(-1), [navigate])

  const navigateReplace = useCallback(
    (location, state) => navigate(location, { replace: true, state: location.state || state }),
    [navigate],
  )

  const updateLocationState = useCallback(
    (change) => {
      navigate(locationRef.current, {
        replace: true,
        state: {
          ...locationRef.current.state,
          ...change,
        },
      })
    },
    [navigate],
  )

  useEffect(() => {
    locationRef.current = location
  }, [location])

  return {
    navigateTo,
    navigateReplace,
    navigateBack,
    updateLocationState,
    previousUrl: locationRef.current.pathname,
  }
}
